import { Stack } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const ProvidersContainer = styled(Stack)`
  && {
    grid-template-columns: repeat(1, 1fr);
    gap: ${rem(16)};
    padding: 0 0 ${rem(48)};

    ${media.desktopSmall} {
      grid-template-columns: repeat(2, 1fr);
    }
  }
`;

export default ProvidersContainer;
